import { render, staticRenderFns } from "./numberComponents.vue?vue&type=template&id=029a2d73&scoped=true&lang=pug&"
import script from "./numberComponents.vue?vue&type=script&lang=js&"
export * from "./numberComponents.vue?vue&type=script&lang=js&"
import style0 from "./numberComponents.vue?vue&type=style&index=0&id=029a2d73&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a2d73",
  null
  
)

export default component.exports